import { Modal } from "antd";
import styled from "styled-components";

export const StyledDIModal = styled(Modal)`
    .ant-modal-content {
        padding: 0 !important;
    }
`;
